export default __webpack_public_path__ + "static/media/logo.0825c73e.webp";